<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>审批</el-breadcrumb-item>
      <el-breadcrumb-item>招聘</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="ShangJigouName" label="公司名称" min-width="9%"></el-table-column>
          <el-table-column prop="CurJigouName" label="申请部门" min-width="9%"></el-table-column>
          <el-table-column prop="Zpgangwei" label="招聘岗位" min-width="9%"></el-table-column>
          <el-table-column prop="Zpyaoqiu" label="招聘要求" min-width="23%"></el-table-column>
          <el-table-column prop="Zpdate" label="到岗日期" min-width="9%"></el-table-column>
          <el-table-column prop="Createtime" label="申请日期" min-width="7%"></el-table-column>
          <el-table-column prop="Zpbeizhu" label="备注" min-width="10%"></el-table-column>
          <el-table-column prop="Zpstatusname" label="审批状态" min-width="7%"></el-table-column>
          <el-table-column prop="Name1" label="部门主管" min-width="4%"></el-table-column>
          <el-table-column prop="Name2" label="人事主管" min-width="4%"></el-table-column>
          <el-table-column prop="Name3" label="副总经理" min-width="4%"></el-table-column>
          <el-table-column prop="Name4" label="总经理" min-width="4%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Zpstatus == 1" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Zpstatus == 1 && SubRule_ShenPiZhaoPin_RenShi" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1(scope.row)">人事主管审核</el-button>
              <el-button v-if="scope.row.Zpstatus == 2 && SubRule_ShenPiZhaoPin_DanWei" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe2(scope.row)">副总经理审核</el-button>
              <el-button v-if="scope.row.Zpstatus == 3 && SubRule_ShenPiZhaoPin_DanWeiZong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe3(scope.row)">总经理审核</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <el-dialog
          title="审批"
          :visible.sync="dialogVisible"
          width="20%">
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="ShenHeOK">同意</el-button>
            <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
          </span>
        </el-dialog>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="申请招聘" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">招聘岗位(必填)</span>
          </label>
          <el-input v-model="addForm.zpgangwei"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">招聘要求(必填)</span>
          </label>
          <el-input v-model="addForm.zpyaoqiu"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">到岗日期(必填)</span>
          </label>
          <el-input v-model="addForm.zpdate"></el-input>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input v-model="addForm.zpbeizhu"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

  </el-tabs>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal
  },
  name: 'MyShenPiZhaoPin',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        zpgangwei: '',
        zpyaoqiu: '',
        zpdate: '',
        zpbeizhu: ''
      },
      timer: '',
      // 查询
      keywords: {
        jigouid: '-1',
        jigouname: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogVisible: false,
      apiShenPiZhaoPinSHUrl: '',
      zpid: 0,
      SubRule_ShenPiZhaoPin_RenShi: false,
      SubRule_ShenPiZhaoPin_DanWei: false,
      SubRule_ShenPiZhaoPin_DanWeiZong: false
    }
  },
  mounted () {
    this.apiGetShenPiZhaoPinNum()
    this.apiGetShenPiZhaoPinList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiZhaoPin_RenShi', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiZhaoPin_RenShi = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiZhaoPin_DanWei', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiZhaoPin_DanWei = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiZhaoPin_DanWeiZong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiZhaoPin_DanWeiZong = true
      }
    })
  },
  methods: {
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickadd () {
      this.apiAddShenPiZhaoPin()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    ShenHe1 (row) {
      this.dialogVisible = true
      this.apiShenPiZhaoPinSHUrl = Vue.prototype.global.Url_ShenPiZhaoPinSH1
      this.zpid = row.Id
    },
    ShenHe2 (row) {
      this.dialogVisible = true
      this.apiShenPiZhaoPinSHUrl = Vue.prototype.global.Url_ShenPiZhaoPinSH2
      this.zpid = row.Id
    },
    ShenHe3 (row) {
      this.dialogVisible = true
      this.apiShenPiZhaoPinSHUrl = Vue.prototype.global.Url_ShenPiZhaoPinSH3
      this.zpid = row.Id
    },
    ShenHeOK () {
      this.dialogVisible = false
      this.apiShenPiZhaoPinSH(1)
    },
    ShenHeNO () {
      this.dialogVisible = false
      this.apiShenPiZhaoPinSH(-1)
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiZhaoPin(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetShenPiZhaoPinNum()
      this.apiGetShenPiZhaoPinList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetShenPiZhaoPinList()
    },
    apiGetShenPiZhaoPinNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiZhaoPinNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetShenPiZhaoPinList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiZhaoPinList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddShenPiZhaoPin: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        zpgangwei: that.addForm.zpgangwei,
        zpyaoqiu: that.addForm.zpyaoqiu,
        zpdate: that.addForm.zpdate,
        zpbeizhu: that.addForm.zpbeizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddShenPiZhaoPin, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiZhaoPinNum()
            that.apiGetShenPiZhaoPinList()

            // 清空添加
            that.addForm.zpgangwei = ''
            that.addForm.zpyaoqiu = ''
            that.addForm.zpdate = ''
            that.addForm.zpbeizhu = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelShenPiZhaoPin: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        zpid: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelShenPiZhaoPin, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiZhaoPinNum()
            that.apiGetShenPiZhaoPinList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiZhaoPinSH: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        zpid: that.zpid,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiZhaoPinSHUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiZhaoPinNum()
            that.apiGetShenPiZhaoPinList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
